(() => {
  if (window.__peUpsellSliderInit) return;
  window.__peUpsellSliderInit = true;

  function getUpsellElementsByKey(key) {
    const track = document.getElementById(`UpsellSliderWrap-${key}`);
    const prev = document.querySelector(`[data-upsell-prev="${key}"]`);
    const next = document.querySelector(`[data-upsell-next="${key}"]`);
    return { track, prev, next };
  }

  function updateUpsellSliderState(key) {
    const { track, prev, next } = getUpsellElementsByKey(key);
    if (!track || !prev || !next) return;

    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    const left = track.scrollLeft;
    const eps = 1;

    const atStart = left <= eps;
    const atEnd = left >= (maxScroll - eps);

    prev.disabled = atStart;
    next.disabled = atEnd;

    // Guard against transient layout states that can disable both buttons.
    if (maxScroll > eps && prev.disabled && next.disabled) {
      next.disabled = false;
    }
  }

  function updateAllUpsellSliderStates() {
    document.querySelectorAll('[data-upsell-prev]').forEach((button) => {
      const key = button.getAttribute('data-upsell-prev');
      if (key) updateUpsellSliderState(key);
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-upsell-prev], [data-upsell-next]');
    if (!button) return;

    const isPrev = button.hasAttribute('data-upsell-prev');
    const key = isPrev ? button.getAttribute('data-upsell-prev') : button.getAttribute('data-upsell-next');
    if (!key) return;

    const { track } = getUpsellElementsByKey(key);
    if (!track) return;

    const direction = isPrev ? -1 : 1;
    track.scrollBy({ left: direction * Math.max(280, track.clientWidth * 0.8), behavior: 'smooth' });
    setTimeout(() => updateUpsellSliderState(key), 220);
  });

  document.addEventListener('scroll', (event) => {
    const track = event.target.closest && event.target.closest('[id^="UpsellSliderWrap-"]');
    if (!track) return;

    const key = track.id.replace('UpsellSliderWrap-', '');
    updateUpsellSliderState(key);
  }, { passive: true, capture: true });

  document.addEventListener('page:loaded', updateAllUpsellSliderStates);
  document.addEventListener('DOMContentLoaded', updateAllUpsellSliderStates);
  window.addEventListener('load', updateAllUpsellSliderStates);
  window.addEventListener('resize', updateAllUpsellSliderStates);
})();
